import { m } from "framer-motion";
import { useEffect, useState } from "react";
// @mui
import {
  List,
  Stack,
  Badge,
  IconButton,
  Typography,
  Button,
  Divider,
} from "@mui/material";
// _mock
import NotificationItem from "./notification-item";
import { Link } from "react-router-dom";
import Iconify from "components/minimal/iconify";
import Scrollbar from "components/minimal/scrollbar";
import { varHover } from "components/minimal/animate";
import CustomPopover, { usePopover } from "components/minimal/custom-popover";
import useApiServices from "api/useApiServices";
import { HOST_API } from "config-global";

// ----------------------------------------------------------------------

export default function NotificationsPopover() {
  const popover = usePopover();
  const { useGetListApi } = useApiServices();

  const { data: notificationsArr } = useGetListApi<any["notifications"]>({
    url: `${HOST_API}/api/admin/notifications`,
  });

  const [notifications, setNotifications] = useState(notificationsArr?.items);
  const [unreadNotificationCount, setUnreadNotificationCount] = useState<
    number | undefined
  >(0);

  useEffect(() => {
    setNotifications(notificationsArr?.items);
    setUnreadNotificationCount(
      notificationsArr?.items?.filter((notification: any) => !notification.read)
        .length
    );
  }, [notificationsArr?.items]);

  const renderHead = (
    <Stack
      direction="row"
      alignItems="center"
      sx={{ py: 2, pl: 2.5, pr: 1, minHeight: 68 }}
    >
      <Typography variant="h6" sx={{ flexGrow: 1 }}>
        Notifications
      </Typography>

      {/* <IconButton onClick={popover.onClose}>
        <Iconify icon="mingcute:close-line" />
      </IconButton> */}
    </Stack>
  );

  const renderList = (
    <Scrollbar>
      <List disablePadding>
        {notifications?.map((notification: any) => (
          <NotificationItem key={notification.id} notification={notification} />
        ))}
      </List>
    </Scrollbar>
  );

  return (
    <>
      <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        color={popover.open ? "primary" : "default"}
        onClick={popover.onOpen}
      >
        <Badge
          badgeContent={
            unreadNotificationCount !== 0 ? unreadNotificationCount : "0"
          }
          color="error"
        >
          <Iconify
            icon="solar:bell-bing-bold-duotone"
            width={27}
            color="white"
          />
        </Badge>
      </IconButton>

      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        sx={{ width: 400 }}
      >
        {renderHead}
        <Scrollbar sx={{ height: 320 }}>{renderList}</Scrollbar>
        <Divider />
        <Button fullWidth sx={{ borderRadius: "0px 0px 10px 10px;" }}>
          <Link
            style={{ color: "#FFAB8A", textDecoration: "none" }}
            to={`/dashboard/notifications`}
          >
            See All
          </Link>
        </Button>
      </CustomPopover>
    </>
  );
}
